/*
    rxConnect® ePrescribing Middleware by HITORI.
    © 2025 HITORI (Melbourne, Australia). All rights reserved.
    Website: https://hitori-inc.com

    This software is proprietary and confidential.
    Unauthorised copying, distribution, or modification of this file, via any medium, is strictly prohibited.

    Styling and theming by licensed third parties is permitted under applicable agreements.
*/

const API_BASE_URL = "https://rxconnect-api.hormn.com";

    
async function makeRequest(method, endpoint, body) {
      const queryParams = new URLSearchParams(window.location.search);
      const token = queryParams.get("t");
      const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
      };
      const options = { method, headers };
      if (body) {
            options.body = JSON.stringify(body);
      }
      try {
            const response = await fetch(`${API_BASE_URL}/${endpoint}`, options);
            const text = await response.text();
            try {
                  const data = JSON.parse(text);
                  if (!response.ok) {
                        throw new Error(data.error || "Something went wrong");
                  }
                  return data;
            } catch (jsonError) {
                  console.error("Response is not JSON:", text);
                  throw new Error("Unexpected response format. Check API endpoint.");
            }
      } catch (error) {
            console.error("Network error:", error);
            throw error;
      }
}

const apiService = {
      post: (endpoint, body) => makeRequest("POST", endpoint, body),
      get: (endpoint) => makeRequest("GET", endpoint),
      patch: (endpoint, body) => makeRequest("PATCH", endpoint, body),
      delete: (endpoint) => makeRequest("DELETE", endpoint),
};

export default apiService;
